export enum TherapistAvailabilityWidgetEnum {
    ageGroup = 'ageGroup',
    insurancePlan = 'insurancePlan',
    serviceType = 'serviceType',
    headingTextForAvailabilityWidget = 'BOOK YOUR FIRST MEETING',
    SELF_MATCHING_CLIENT_INTAKE = 'SELF_MATCHING_CLIENT_INTAKE',
    INTAKE_ONLINE = 'INTAKE_ONLINE',
    INTAKE_IN_PERSON = 'INTAKE_IN_PERSON',
    online_or_in_person = 'online or in person',
    Online = 'Online',
    No_Insurance = 'I do not want to use insurance',
    choose_insurance = `Choose Insurance`,
    choose_servie_type = `Choose Service Type`,
    choose_client_age = `Choose Client's Age`,
    update_availability = 'Update Availability',
    view_availability = 'View Availability',
    Psychiatry = 'psychiatryTherapyChoiceV1',
    Assessment = 'Assessment',
    Group = 'groupTherapyChoiceV1',
    Family = 'familyTherapyChoiceV1',
    Couples = 'couplesTherapyChoiceV1',
    Individual = 'individualTherapyChoiceV1',
    CLIENT = 'CLIENT',
    work_with_ages = 'Works With Ages',
    work_with_age_groups = 'WORK WITH AGE GROUPS',
    single_select = 'single-select',
    commonly_used = 'COMMONLY_USED',
    MOST = 'MOST',
    Online_or_In_Person = 'Online or In Person',
    All_Insurance_Plan = 'All Insurance Plans',
    INSURANCES = 'INSURANCES',
    multi_checkbox = 'multi-checkbox',
  }
  